import type {Component} from 'grapesjs';
import type {PrimaryConfigOptions} from '../index';
import type {ListType, PropertyList} from '../styles.types';

export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const styleManager = editor.StyleManager;

  styleManager.addType(window.PMW.emails.styles.ID_LIST, {
    create(data: any): HTMLDivElement {
      const props = data.props as ListType;
      
      const container = document.createElement('div');
      const titleEl = document.createElement('span');
      const el = document.createElement('ul');
      const component = props.component ?? editor.getSelected();

      const isToggleable = typeof props.toggleable === 'boolean' ? props.toggleable : false;
      const title = typeof props.title === 'string' ? props.title : props.property;

      container.className = 'pmw-list-style-type-container';
      titleEl.className = 'pmw-list-style-type-title';
      el.className = 'pmw-list-style-type';

      titleEl.innerHTML = title;
      container.appendChild(titleEl);

      props.list.forEach((item: PropertyList): void => {
        const property = item.property ?? props.property;
        const parentClasses = item.parentClasses ?? '';
        const li = document.createElement('li');
        const icon = document.createElement('i');
        const label = document.createElement('label');
        const selectable = item.selectable ?? true;

        li.title = item.name;
        li.className = `pmw-list-item-style-type ${parentClasses}`;
        li.setAttribute('data-value', item.value);
        icon.className = 'pmw-icon -square size-icon-16 -transparent ' + item.classes;
        label.className = 'pmw-list-item-style-type-label body-xs' + (item.label ? '' : ' _hidden');
        label.innerHTML = item.label ?? '';

        if (props.defaults === item.value && selectable) {
          li.className += ' -selected';
        }

        if (isToggleable && isLiPreselected(component ?? null, li, property, item.value)) {
          li.className += ' -selected';
        }

        li.appendChild(icon);
        li.appendChild(label);
        el.appendChild(li);
        
        window.PMW.onClick($(li), null, function (this: HTMLElement): void {
          const t = $(this);

          if (isToggleable) {
            t.toggleClass('-selected');
          } else {
            t.addClass('-selected').siblings('li').removeClass('-selected');
          }

          saveListData(component ?? null, t.parents('ul'), props.property);
          item.callback.call(this);
        });
      });

      container.appendChild(el);
      return container;
    },
    
    emit(): void {
      // Empty emit method
    },

    update(): void {
      // Empty update method
    }
  });

  function getListDataKey(component: Component | null, listProperty: string): string {
    const componentId = component?.ccid;
    return 'pmw-list-' + listProperty + '-' + componentId;
  }

  function saveListData(component: Component | null, ul: JQuery<Element>, listProperty: string): void {
    const key = getListDataKey(component, listProperty);

    const values: Record<string, boolean>[] = [];
    ul.find('li').each(function() {
      const t = $(this);
      const obj: Record<string, boolean> = {};
      const dataValue = t.attr('data-value');
      if (dataValue) {
        obj[dataValue] = t.hasClass('-selected');
        values.push(obj);
      }
    });

    $(document).data(key, values);
  }

  function isLiPreselected(component: Component | null, li: HTMLLIElement, listProperty: string, listValue: string): boolean {
    return isValueSet(component, listProperty, listValue) || isListDataSet(component, li, listProperty);
  }

  function isValueSet(component: Component | null, property: string, value: string): boolean {
    const styles = component?.getStyle() ?? {};
    const propValue = styles[property];
    return Object.prototype.hasOwnProperty.call(styles, property) && 
           typeof propValue === 'string' && 
           propValue.split(' ').includes(value);
  }

  function isListDataSet(component: Component | null, li: HTMLLIElement, listProperty: string): boolean {
    const key = getListDataKey(component, listProperty);
    const data = $(document).data(key);
    const t = $(li);
    let isDataSet = false;

    if (data && data.length > 0) {
      data.forEach((liObject: Record<string, boolean>): void => {
        const keyValue = t.attr('data-value');
        if (keyValue && typeof liObject[keyValue] === "boolean" && liObject[keyValue] === true) {
          isDataSet = true;
        }
      });
    }

    return isDataSet;
  }
};